var _style, _defs, _path, _rect, _rect2, _rect3, _rect4, _rect5, _defs2, _g, _path2, _rect6, _path3, _path4, _path5, _polyline, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _g2, _path16, _polyline2, _path17, _path18, _path19, _circle, _path20, _path21, _path22, _path23, _ellipse, _ellipse2, _circle2, _circle3, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _polygon, _path34, _path35, _polygon2, _g3, _g4, _g5, _g6, _g7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWorkInProgress(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 792 612",
    style: {
      enableBackground: "new 0 0 792 612"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{clip-path:url(#SVGID_2_);}\r\n\t.st1{fill:#FFC6A6;}\r\n\t.st2{opacity:0.5;fill:#FFC6A6;}\r\n\t.st3{clip-path:url(#Path_214-2_2_);}\r\n\t.st4{fill:#F9DED2;}\r\n\t.st5{opacity:0.21;fill:#FFFFFF;}\r\n\t.st6{fill:#FFFFFF;}\r\n\t.st7{fill:#F0F4FF;}\r\n\t.st8{clip-path:url(#Path_214-2_2_);fill:#F9DED2;}\r\n\t.st9{fill:#F9ABA0;}\r\n\t.st10{fill:#FC968B;}\r\n\t.st11{fill:url(#SVGID_3_);}\r\n\t.st12{fill:#E26E20;}\r\n\t.st13{fill:#E6E6E8;}\r\n\t.st14{fill:#EC8131;}\r\n\t.st15{fill:#FCB330;}\r\n\t.st16{fill:none;stroke:#E6E6E8;stroke-width:1.524;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st17{fill:none;stroke:#E27E71;stroke-width:2.286;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st18{fill:#CC7400;}\r\n\t.st19{fill:#242833;}\r\n\t.st20{fill:url(#SVGID_4_);}\r\n\t.st21{fill:url(#SVGID_5_);}\r\n\t.st22{fill:none;stroke:#FFDBB3;stroke-width:0.907;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st23{fill:#E67627;}\r\n\t.st24{fill:#AEE6FF;}\r\n\t.st25{fill:#E27E71;}\r\n\t.st26{fill:#F87847;}\r\n\t.st27{fill:#BF5F21;}\r\n\t.st28{opacity:0.43;fill:#EBF6FF;enable-background:new    ;}\r\n\t.st29{fill:#E6E6E6;}\r\n\t.st30{opacity:0.3;fill:#FCB330;}\r\n\t.st31{fill:#FFC973;}\r\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    width: 792,
    height: 612
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_214-2",
    className: "st1",
    d: "M237.5,672.9c1.1,1.1,1.7,1.7,1.7,1.7l346.8,0.5l366.3,0.6c0,0,0.4-0.3,1.2-1 c12.1-10.1,110.5-95.8,90.4-200.1c-1.8-9.2-4.1-18.4-6.9-27.3c-16.2-51.1-36.1-73.2-64.3-97.9c-47.4-41.6-87.7-117.9-127.8-176.7 C767.4,59.1,514.9,46.2,454,112c-89.9,97.2,23.9,135.3-206.1,289.1c-47.7,31.9-59.1,79.7-64.8,115.3 C170,599.3,226.9,662,237.5,672.9z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 444.1,
    y: 199.4,
    className: "st2",
    width: 120.5,
    height: 24.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 444.1,
    y: 232.6,
    className: "st2",
    width: 120.5,
    height: 24.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 444.1,
    y: 265.8,
    className: "st2",
    width: 120.5,
    height: 24.5
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 444.1,
    y: 299,
    className: "st2",
    width: 120.5,
    height: 24.5
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 444.1,
    y: 332.2,
    className: "st2",
    width: 120.5,
    height: 24.5
  })), /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "Path_214-2_1_",
    d: "M237.5,673.1c1.1,1.1,1.7,1.7,1.7,1.7l346.8,0.5l366.3,0.6c0,0,0.4-0.3,1.2-1 c12.1-10.1,110.5-95.8,90.4-200.1c-1.8-9.2-4.1-18.4-6.9-27.3c-16.2-51.1-36.1-73.2-64.3-97.9 c-47.4-41.6-87.7-117.9-127.8-176.7C767.4,59.2,514.8,46.4,454,112.2c-89.9,97.2,23.9,135.3-206.1,289.1 c-47.7,31.9-59.1,79.7-64.8,115.3C170,599.4,226.9,662.2,237.5,673.1z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "Path_214-2_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Path_214_x002D_2_1_",
    style: {
      overflow: "visible"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M118.4,708.6h302.8V183.6C383,191.4,340.4,207.5,293,235c-6.9,4-13.9,8.2-20.9,12.7 c-8.6,5.5-16.8,11.2-24.6,17c-5,3.8-9.9,7.7-14.6,11.7c-4.9,4.1-9.6,8.3-14.1,12.6C68.7,431.2,107.5,658.6,118.4,708.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1111.7,703.5h-372V58.4c46.8,9.6,99.2,29.4,157.4,63.2c8.4,4.9,17,10.1,25.7,15.6 c10.6,6.7,20.7,13.7,30.2,20.9c6.2,4.7,12.1,9.4,17.9,14.3c6,5.1,11.8,10.3,17.4,15.5C1172.7,362.7,1125,642.1,1111.7,703.5z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 304.4,
    y: 355,
    className: "st1",
    width: 81.1,
    height: 138.2
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "328.5,355 388.6,438.6 388.6,462.2 308.8,355  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 166.4,
    y: 357.7,
    className: "st1",
    width: 83.7,
    height: 138.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M247.5,264.8h178.9l6.9-29.8H293c-6.9,4-13.9,8.2-20.9,12.7C263.4,253.2,255.3,258.9,247.5,264.8z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 361.9,
    y: 289.1,
    className: "st7",
    width: 28.9,
    height: 10.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 325.4,
    y: 311.4,
    className: "st7",
    width: 32.4,
    height: 10.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 291.3,
    y: 289.1,
    className: "st7",
    width: 34.8,
    height: 10.1
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "190,357.7 250.2,441.3 250.2,488.2 166.4,383.9 166.4,357.7  "
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M1251.3,152.7v-6.4H373.1v6.4h2.2l9.6,16h-11.9v6.4h878.2v-6.4h-13.2l9.6-16H1251.3z M408.6,168.7H390 l9.3-15.4L408.6,168.7z M402,152.7h18.1l-9.1,15.1L402,152.7z M422.8,153.3l9.3,15.4h-18.6L422.8,153.3z M425.5,152.7h18.1 l-9.1,15.1L425.5,152.7z M446.4,153.3l9.3,15.4h-18.6L446.4,153.3z M449.1,152.7h18.1l-9.1,15.1L449.1,152.7z M469.9,153.3 l9.3,15.4h-18.6L469.9,153.3z M472.7,152.7h18.1l-9.1,15.1L472.7,152.7z M493.5,153.3l9.3,15.4h-18.6L493.5,153.3z M496.2,152.7 h18.1l-9.1,15.1L496.2,152.7z M517.1,153.3l9.3,15.4h-18.6L517.1,153.3z M519.8,152.7h18.1l-9.1,15.1L519.8,152.7z M540.6,153.3 l9.3,15.4h-18.6L540.6,153.3z M543.3,152.7h18.1l-9.1,15.1L543.3,152.7z M564.2,153.3l9.3,15.4h-18.6L564.2,153.3z M566.9,152.7 H585l-9.1,15.1L566.9,152.7z M587.7,153.3l9.3,15.4h-18.6L587.7,153.3z M590.5,152.7h18.1l-9.1,15.1L590.5,152.7z M611.3,153.3 l9.3,15.4H602L611.3,153.3z M614,152.7h18.1l-9.1,15.1L614,152.7z M634.9,153.3l9.3,15.4h-18.6L634.9,153.3z M637.6,152.7h18.1 l-9.1,15.1L637.6,152.7z M658.4,153.3l9.3,15.4h-18.6L658.4,153.3z M661.1,152.7h18.1l-9.1,15.1L661.1,152.7z M682,153.3 l9.3,15.4h-18.6L682,153.3z M684.7,152.7h18.1l-9.1,15.1L684.7,152.7z M705.5,153.3l9.3,15.4h-18.6L705.5,153.3z M708.2,152.7 h18.1l-9.1,15.1L708.2,152.7z M729.1,153.3l9.3,15.4h-18.6L729.1,153.3z M731.8,152.7h18.1l-9.1,15.1L731.8,152.7z M752.6,153.3 l9.3,15.4h-18.6L752.6,153.3z M755.4,152.7h18.1l-9.1,15.1L755.4,152.7z M776.2,153.3l9.3,15.4h-18.6L776.2,153.3z M778.9,152.7 H797l-9.1,15.1L778.9,152.7z M799.8,153.3l9.3,15.4h-18.6L799.8,153.3z M802.5,152.7h18.1l-9.1,15.1L802.5,152.7z M823.3,153.3 l9.3,15.4H814L823.3,153.3z M826,152.7h18.1l-9.1,15.1L826,152.7z M846.9,153.3l9.3,15.4h-18.6L846.9,153.3z M849.6,152.7h18.1 l-9.1,15.1L849.6,152.7z M870.4,153.3l9.3,15.4h-18.6L870.4,153.3z M873.2,152.7h18.1l-9.1,15.1L873.2,152.7z M894,153.3 l9.3,15.4h-18.6L894,153.3z M896.7,152.7h18.1l-9.1,15.1L896.7,152.7z M917.6,153.3l9.3,15.4h-18.6L917.6,153.3z M920.3,152.7 h18.1l-9.1,15.1L920.3,152.7z M941.1,153.3l9.3,15.4h-18.6L941.1,153.3z M943.8,152.7H962l-9.1,15.1L943.8,152.7z M964.7,153.3 l9.3,15.4h-18.6L964.7,153.3z M967.4,152.7h18.1l-9.1,15.1L967.4,152.7z M988.2,153.3l9.3,15.4h-18.6L988.2,153.3z M990.9,152.7 h18.1l-9.1,15.1L990.9,152.7z M1011.8,153.3l9.3,15.4h-18.6L1011.8,153.3z M1014.5,152.7h18.1l-9.1,15.1L1014.5,152.7z  M1035.3,153.3l9.3,15.4h-18.6L1035.3,153.3z M1038.1,152.7h18.1l-9.1,15.1L1038.1,152.7z M1058.9,153.3l9.3,15.4h-18.6 L1058.9,153.3z M1061.6,152.7h18.1l-9.1,15.1L1061.6,152.7z M1082.5,153.3l9.3,15.4h-18.6L1082.5,153.3z M1085.2,152.7h18.1 l-9.1,15.1L1085.2,152.7z M1106,153.3l9.3,15.4h-18.6L1106,153.3z M1108.7,152.7h18.1l-9.1,15.1L1108.7,152.7z M1129.6,153.3 l9.3,15.4h-18.6L1129.6,153.3z M1132.3,152.7h18.1l-9.1,15.1L1132.3,152.7z M1153.1,153.3l9.3,15.4h-18.6L1153.1,153.3z  M1155.9,152.7h18.1l-9.1,15.1L1155.9,152.7z M1176.7,153.3l9.3,15.4h-18.6L1176.7,153.3z M1179.4,152.7h18.1l-9.1,15.1 L1179.4,152.7z M1200.3,153.3l9.3,15.4H1191L1200.3,153.3z M1203,152.7h18.1l-9.1,15.1L1203,152.7z M1223.8,153.3l9.3,15.4 h-18.6L1223.8,153.3z M396.5,152.7l-9.1,15.1l-9.1-15.1H396.5z M1235.6,167.8l-9.1-15.1h18.1L1235.6,167.8z"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 655.3,
    y: 132.8,
    className: "st8",
    width: 94.2,
    height: 66.6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M719.6,679.5h6.4l0-878.2h-6.4v2.2l-16,9.6v-11.9h-6.4l0,878.2h6.4v-13.2l16,9.6V679.5z M703.6-163.3 l0-18.6l15.4,9.3L703.6-163.3z M719.6-169.8v18.1l-15.1-9.1L719.6-169.8z M719.1-149l-15.4,9.3v-18.6L719.1-149z M719.6-146.3 l0,18.1l-15.1-9.1L719.6-146.3z M719.1-125.4l-15.4,9.3v-18.6L719.1-125.4z M719.6-122.7v18.1l-15.1-9.1L719.6-122.7z  M719.1-101.9l-15.4,9.3v-18.6L719.1-101.9z M719.6-99.2V-81l-15.1-9.1L719.6-99.2z M719.1-78.3L703.6-69v-18.6L719.1-78.3z  M719.6-75.6v18.1l-15.1-9.1L719.6-75.6z M719.1-54.8l-15.4,9.3V-64L719.1-54.8z M719.6-52v18.1L704.6-43L719.6-52z M719.1-31.2 l-15.4,9.3v-18.6L719.1-31.2z M719.6-28.5v18.1l-15.1-9.1L719.6-28.5z M719.1-7.6l-15.4,9.3v-18.6L719.1-7.6z M719.6-4.9v18.1 l-15.1-9.1L719.6-4.9z M719.1,15.9l-15.4,9.3V6.6L719.1,15.9z M719.6,18.6v18.1l-15.1-9.1L719.6,18.6z M719.1,39.5l-15.4,9.3 V30.2L719.1,39.5z M719.6,42.2v18.1l-15.1-9.1L719.6,42.2z M719.1,63l-15.4,9.3V53.8L719.1,63z M719.6,65.8v18.1l-15.1-9.1 L719.6,65.8z M719.1,86.6l-15.4,9.3l0-18.6L719.1,86.6z M719.6,89.3v18.1l-15.1-9.1L719.6,89.3z M719.1,110.2l-15.4,9.3v-18.6 L719.1,110.2z M719.6,112.9V131l-15.1-9.1L719.6,112.9z M719.1,133.7l-15.4,9.3v-18.6L719.1,133.7z M719.6,136.4v18.1l-15.1-9.1 L719.6,136.4z M719.1,157.3l-15.4,9.3V148L719.1,157.3z M719.6,160v18.1l-15.1-9.1L719.6,160z M719.1,180.8l-15.4,9.3v-18.6 L719.1,180.8z M719.6,183.5v18.1l-15.1-9.1L719.6,183.5z M719.1,204.4l-15.4,9.3v-18.6L719.1,204.4z M719.6,207.1v18.1 l-15.1-9.1L719.6,207.1z M719.1,227.9l-15.4,9.3v-18.6L719.1,227.9z M719.6,230.7v18.1l-15.1-9.1L719.6,230.7z M719.1,251.5 l-15.4,9.3v-18.6L719.1,251.5z M719.6,254.2v18.1l-15.1-9.1L719.6,254.2z M719.1,275.1l-15.4,9.3v-18.6L719.1,275.1z  M719.6,277.8v18.1l-15.1-9.1L719.6,277.8z M719.1,298.6l-15.4,9.3v-18.6L719.1,298.6z M719.6,301.3v18.1l-15.1-9.1L719.6,301.3 z M719.1,322.2l-15.4,9.3v-18.6L719.1,322.2z M719.6,324.9V343l-15.1-9.1L719.6,324.9z M719.1,345.7l-15.4,9.3v-18.6 L719.1,345.7z M719.6,348.5v18.1l-15.1-9.1L719.6,348.5z M719.1,369.3l-15.4,9.3l0-18.6L719.1,369.3z M719.6,372v18.1l-15.1-9.1 L719.6,372z M719.1,392.9l-15.4,9.3v-18.6L719.1,392.9z M719.6,395.6l0,18.1l-15.1-9.1L719.6,395.6z M719.1,416.4l-15.4,9.3 v-18.6L719.1,416.4z M719.6,419.1v18.1l-15.1-9.1L719.6,419.1z M719.1,440l-15.4,9.3v-18.6L719.1,440z M719.6,442.7v18.1 l-15.1-9.1L719.6,442.7z M719.1,463.5l-15.4,9.3v-18.6L719.1,463.5z M719.6,466.2v18.1l-15.1-9.1L719.6,466.2z M719.1,487.1 l-15.4,9.3v-18.6L719.1,487.1z M719.6,489.8v18.1l-15.1-9.1L719.6,489.8z M719.1,510.6l-15.4,9.3v-18.6L719.1,510.6z  M719.6,513.4v18.1l-15.1-9.1L719.6,513.4z M719.1,534.2l-15.4,9.3v-18.6L719.1,534.2z M719.6,536.9V555l-15.1-9.1L719.6,536.9z  M719.1,557.8l-15.4,9.3v-18.6L719.1,557.8z M719.6,560.5v18.1l-15.1-9.1L719.6,560.5z M719.1,581.3l-15.4,9.3V572L719.1,581.3z  M719.6,584v18.1l-15.1-9.1L719.6,584z M719.1,604.9l-15.4,9.3v-18.6L719.1,604.9z M719.6,607.6v18.1l-15.1-9.1L719.6,607.6z  M719.1,628.4l-15.4,9.3l0-18.6L719.1,628.4z M719.6,631.2v18.1l-15.1-9.1L719.6,631.2z M719.1,652l-15.4,9.3v-18.6L719.1,652z  M719.6-175.3l-15.1-9.1l15.1-9.1V-175.3z M704.6,663.8l15.1-9.1l0,18.1L704.6,663.8z"
  }))), /*#__PURE__*/React.createElement("g", null, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M709.5,413.8c0,0,21.1,24.6,44.7,21.2c-0.5-9.4-7.9-22.1-12.7-32.8c-8.7-19.4-41.9-77-41.9-77l-23.2,34.9 C676.4,360.1,710,413.5,709.5,413.8z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M682.3,352.1l-0.6,0.1l-5.3,7.9c0,0,33.6,53.4,33.1,53.7c0,0,2.7,3.1,7.2,7h5.8L682.3,352.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 579.5619,
    y1: 190.6676,
    x2: 580.9514,
    y2: 361.1003
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#59381D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#BE9C74"
    }
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "st11",
    points: "566.2,198.4 557.9,273.8 558.6,318.8 602.7,281.3 600.7,244.8  "
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M586.5,288c-9-0.7-34.3,19.3-34.3,19.3s-25,42.1-29.2,46.4l13.7,8l-2.9,7c0,0,21.8,11.8,39,11.5 c14.5-24.5,19.8-53.4,19.8-53.4s4.3-18.8,0.8-26.7C588.8,290,588.8,288.2,586.5,288z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M568.8,181.5c0,0-10.5,46.4,10.4,71.8c4.9,4.4,15.1,2.2,15.1,2.2l-0.5,25.4c0,0-13.1,13-19,23.7 c-5.8,10.8-26.4,27-25,38.2c1.3,11.2,12.5,26.9,12.5,26.9l18.6,60.7c0,0,46.8,1.8,46.1,0.4c-0.7-1.3,33.6-85.4,33.6-85.4 l8.5-60.7c0,0-17.2-9.9-33.8-7.6l-10.8-0.9l3.1-45.3c0,0,10.1-18.6,6.5-39.2C630.6,171.1,580.6,148.4,568.8,181.5z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M631.9,228.6l-1.1-12.3c0,0,1.5-5.8,5-5.8C639.4,210.5,648.7,223.6,631.9,228.6z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M581.2,700.4l-0.9,18.2c0,0,6,10.2,5.4,23.9C585,756.2,573.7,850,573.7,850l-13.1,0.3l-0.5-10l-7-151.9"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M621.4,695.7l4.4,17.7c0,0,8.6,8,12,21.3c3.4,13.3,19.5,106.4,19.5,106.4l-12.5,4.1l-3.3-9.5L591,692.3"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M621.5,884.4c0,0,24.5-21.2,20.8-45.9c11.3,0.8,14.2-0.3,14.2-0.3l2.2,6.8c0,0-12.6,8-13.2,27.2 C644.6,880.4,621.5,884.4,621.5,884.4z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M658.7,844.9c0,0,11.6,0.9,7.7,17.4c0.1,12.4,1.3,19.8,1.3,19.8l-4.6,1.4l-6-18.7c0,0-6.2,11.6-6.6,20.7 c-26.4,8.5-35.1,10.5-35.1,10.5s-1.3-8.4,6.5-12.2c7.8-3.9,20.3-8.4,25.8-24C653.2,844.3,658.7,844.9,658.7,844.9z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M516.8,687.1c0,0,13.6-26.1,23.7-112.2c3.9-70.3,19-116.5,25.4-134.4c-0.5-7.3-5-25.4-6.1-67.1 c-17.5-26.4-13.5-41.2,1.8-60.8c11.2-14.4,32.1-31.8,32.1-31.8s-30.3,41.1-8.4,63c8.1-4.5,53.3-56,53.3-56l26.1,47.2l-19.9,106 c8.5,17.9,34.1,62.6,32.4,120.7c-2.2,76.6,34.3,118.9,34.3,118.9l-14.6,2.7l4.3,16.3c-17.9,13.4-45.3,5.6-45.3,5.6 s-27,7.9-41,6.9c-11.3-0.8-22.4-4.5-30.8-10.8c-24.5,0-45.4-0.6-43.6-10.2C535.3,690.6,516.8,687.1,516.8,687.1z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M588.7,281.1c0,0-49.5,96-16.9,212.4l-36.3-5.6c0,0,17.4-76.1,9.2-119.5c-8.2-43.4,29.1-80.2,29.1-80.2 L588.7,281.1z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M640.1,278.4c0,0-49.6,34.4-36.3,217.2c55.1,8.2,79.4,0.5,79.4,0.5l-15.8-134.8c0,0-7.1-55.7,25-64.3 c-4.8-31.1-50.6-24.5-50.6-24.5"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st13",
    points: "622.4,425.7 674.9,425.8 672.6,406.8 613.6,403.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st13",
    points: "677,444 616.3,440.7 625.1,462.8 679.2,463  "
  }))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M655.4,304.4c0,0-2.9-24.7,16.9-16.2c19.7,8.5,29.1,27.1,47.5,35.3c-7,10.6-16.2,15-16.2,15 s-4.6,19.5-35.6,26.3C661.4,342.4,658.4,332.2,655.4,304.4z"
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    className: "st16",
    points: "593,279.4 591.2,319.8 625.4,273.8  "
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M527,881.1c0,0,29.6-13.3,33.2-37.9c10.6,4,13.7,3.8,13.7,3.8l0.2,7.1c0,0-14.3,4-20.5,22.3 C550.3,883.9,527,881.1,527,881.1z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M574,854c0,0,10.9,4.2,2.4,18.9c-3.5,11.9-4.5,19.4-4.5,19.4h-4.8l-0.3-19.6c0,0-9.3,9.3-12.3,17.9 c-27.8,0.6-36.6,0-36.6,0s1.1-8.4,9.7-9.9c8.6-1.5,21.8-2.2,31.6-15.6C568.9,851.8,574,854,574,854z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M594,269.2l0.3-13.8c0,0,13.1-1.9,20.6-8.5C613.8,260,605.9,267.4,594,269.2z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st13",
    cx: 590.7,
    cy: 321.7,
    r: 3.6
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M590,203l-8.4,16.5c0,0,4.6,1.8,6,4.6"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M602,229.2c0,0-1.3,3.5-8.5,4.7c-7.4,1.2-10.6-1.8-10.6-1.8"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M613.6,195c0,0-6.3-5.5-14.2-3.2c-4.2,1.3-2.3-1.6,0.3-2.2C601.7,189.1,611.7,188.9,613.6,195z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M571.2,195c0,0,6.3-5.5,14.2-3.2c4.2,1.3,2.3-1.6-0.3-2.2C583.1,189.1,573.1,188.9,571.2,195z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "st19",
    cx: 603.3,
    cy: 205.8,
    rx: 2.5,
    ry: 3.8
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st19",
    cx: 580.8,
    cy: 205.5,
    rx: 2.5,
    ry: 3.8
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st10",
    cx: 609.6,
    cy: 217.6,
    r: 7.6
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "st10",
    cx: 570.4,
    cy: 216.1,
    r: 4.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 648.1514,
    y1: 180.0464,
    x2: 648.1514,
    y2: 312.2596
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#59381D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#BE9C74"
    }
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M593.4,158.7l0-0.4c0-0.1,0-0.1,0.1-0.2c0.6-4,1.5-8,2.9-11c4.3-9.2,40.5-16.1,60.9,20.6 c9.4,16.3,13,21.3,22.4,29.8c9.4,8.5,10.5,15.9,8.5,22.2c-2,6.3-3.4,6.7,3.1,10.5c6.5,3.8,11.2,11,5.8,20.6 c-5.4,9.6-3.1,8.3,3.4,14.6c6.5,6.3,2.2,17.9-2.7,23.5c-0.9,3.4-2.9,5.8,1.1,10.8c4,4.9-2.9,13.2-2.9,13.2s-23-22.2-34.6-27.4 c-11.1-5-16.5,0.2-20.5,7.1c-2.8,8.2-7.1,3.5-8.5,13.1c-1.6,10.5-6,7.1-11.9,11c-5.8,3.9,0.3,13,0.3,13s-8.3-0.1-13.2-9.4 c-4.9-9.3,6.6-12.9,1.7-21.3c-4.9-8.4,8.1-11.3,3.7-14.9c-4.4-3.6-2.7-8.1-0.4-11.2c2.2-3.1,7.3-5.2,2.4-10 c-4.9-4.8-2.7-11.3,0.7-15.7c3.4-4.4,5.7-6.6,3.4-12.7c-2.4-6-1.9-13.6,2.7-18.8c4-4.6,4.2-9.9,3.8-13.2 c-1.4-6.9-7.5-12.6-9.1-19.8c-2.4-10.5-8.5-13.3-14.6-12.5c-6.1,0.7-9.1,4.2-9.1,4.2S592.3,166.7,593.4,158.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 573.7957,
    y1: 183.3404,
    x2: 573.7957,
    y2: 303.8609
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#59381D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#BE9C74"
    }
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M572.4,179.3c-6,14.6-6.6,29.7-5.5,38.8c0,0,1.4,8.3,0.7,11.1c-0.7,2.9-5,6.6-4.5,9.9 c0.6,3.2,4.9,4.6,1.3,9.1c-3.6,4.4,2.4,4.3,1.8,7.6c-0.6,3.3-4.3,3.9-1.5,6.6c2.9,2.6,1.7,10.2-2.8,13.1 c-4.5,2.9,4.1,8.2,2.7,12.8c-1.4,4.5-3.7,7.3-1.2,9.4c0.3,0.2,0.5,0.5,0.6,0.9c-5.2,3.8-11.8,8.8-11.8,8.8l-0.5,0.8 c0.7-3.9,0.9-7.7-0.2-9.9c-2.9-5.6-4.3-9.5-1.4-13.7c2.8-4.2-1-4.8-2.2-9c-1.1-4.3,7.2-7.8,3.8-13.7c-3.4-6-1.8-7.9,0.1-10.9 c1.9-3,2.5-6.6,0.4-11.7c-2.1-5.1,3.3-6.5,4.2-11.1c0.9-4.6,7.2-8.1,2.3-19.6c-4.9-11.5-7.4-41.9,3.1-53.7 c10.5-11.8,28.5-15.5,37.9-7.5l-7.2,27.3C592.5,174.5,578.4,164.7,572.4,179.3z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M596.5,166.7c0,0,13.7-4.9,19.9,5.1c6.1,10,9.6,26,18.5,29.9s13,11.1,11.2,22.6 c-1.8,11.5,10.6,6.3,9.3,13.4c-1.3,7.2-2.7,8.1,4.3,11.8c7,3.7,3,9.3-0.1,16.6c-3.1,7.3,6,10.3,10,11.8"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M595.8,161.4c0,0,11.9-10.5,21.2-2.8c9.3,7.6,17,24.2,28.2,27.8c11.2,3.6,19.6,11.8,16.9,18.7 c-2.7,6.9-5.8,12.2,3.4,16.3c9.3,4,9.6,8.7,8.2,15.4c-1.3,6.7,0.1,10.5,7,14c6.9,3.6,9.4,8.4,6.7,15.2c-2.7,6.9-0.6,10.8,5.1,13 "
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M598.3,151.8c0,0,18.2-14.5,38.5,2.4c20.3,16.9,18.5,25.4,27.3,30.5c8.8,5.1,12.1,12.5,8.2,22 c-3.9,9.4-0.7,11.2,5.1,14"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M587.4,163.3c0,0-25.4-3.3-26,25.4"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M589.8,157.8c0,0-6.9-6-15.2-1"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M557.7,372.8c0,0,50.7,3.7,51.4,3.7c-28.5,2.2-49.6,1.5-49.6,1.5"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M540.7,691.2c-2.8-0.3-9.3-1.5-14.8-2.5c17.8-38.2,33.2-120.4,33.2-120.4 C556.4,606.6,540.7,691.2,540.7,691.2z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M639.1,569.7l17,135.5c0,0-5.1,1.5-12,3.1L639.1,569.7z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st24",
    points: "432.6,340.1 469.1,461.9 536,471.9 595.4,457.6 654.9,467 652.6,351.6 579.9,335.3 508.7,355.1  "
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M446.5,402.5c0,0-5.7-9.6,1.8-14.4c7.5-4.8,11.5-7.9,15.6,4c4.1,11.9,7.2,17.9,6.1,23.6 c-1.1,5.6-6.9,11.1-11.4,11.5C454.3,427.6,446.5,402.5,446.5,402.5z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M753.3,429.4c-15.9-13.4-42.8-15.6-42.8-15.6c-0.5-0.3-0.9-0.6-1.4-0.9c0.3,0.5,0.4,0.8,0.4,0.8 c-0.5,0.3-32.9-5.5-45.6-13.9c-13.3-15.1-14.5-14.8-27-11.4c-12.5,3.4-12.8,8.3-7.9,22.4c1.6,4.5,2.8,8.2,4.4,11.1l0.1-0.1 c0,0,2.3,6.6,9.6,5.4c7.3-1.3,10.6-2.9,10.6-2.9s8.5,2.9,12.4,5.8c0,0,50.6,19.5,70.5,18.7C753.6,448,756,439.8,753.3,429.4z"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st24",
    points: "508.7,355.1 536,471.9 595.4,457.6 579.9,335.3  "
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M654.2,404.2c0.6,0,1.1-0.6,1.1-1.2c0-0.6-0.6-1.1-1.2-1.1l-8.3,0.6c-0.1,0-0.3,0-0.4,0.1l-16.5,7.9 c0,0.1,0.1,0.2,0.1,0.3c0.2,0.7,0.4,1.3,0.7,1.9l16.5-7.9L654.2,404.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M626.6,403.1l14.8-7.8h9.4c0.6,0,1.1-0.5,1.1-1.1c0-0.6-0.5-1.1-1.1-1.1h-9.7c-0.2,0-0.4,0-0.5,0.1 l-14.4,7.6C626.3,401.5,626.5,402.3,626.6,403.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M647.3,414.6l9.6-0.5c0.6,0,1.1-0.6,1.1-1.2c0-0.6-0.5-1.1-1.2-1.1l-9.8,0.6c-0.2,0-0.3,0-0.4,0.1 l-14.3,7.1c0.3,0.7,0.6,1.4,1,2.1L647.3,414.6z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M464,392.3c0,0,0-0.1,0-0.1c-0.3-0.7-0.5-1.4-0.8-2.1c-4.1,0.9-12.3,3.4-17.7,10.2c0.5,1.3,1,2.2,1,2.2 s0,0.1,0.1,0.2C451.6,395.7,460.2,393.1,464,392.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M466.7,399.8c-0.3-0.7-0.5-1.4-0.8-2.2c-4.6,1.1-12.4,4-17.3,11c0.3,0.9,0.6,1.8,1,2.7 C453.9,403.9,462.2,400.9,466.7,399.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M469.4,407.7c-0.2-0.7-0.4-1.4-0.7-2.2c-4.5,1.7-12.2,5.6-16.2,13.3c0.4,0.9,0.8,1.8,1.3,2.7 C457.1,413.5,464.9,409.4,469.4,407.7z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Android",
    transform: "matrix(0.998, -0.07, 0.07, 0.998, -1188.882, -480.247)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_42",
    x: 1501.3,
    y: 761,
    transform: "matrix(-0.1252 -0.9921 0.9921 -0.1252 964.5208 2378.7258)",
    className: "st19",
    width: 59.4,
    height: 6.3
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_26",
    className: "st19",
    cx: 1536.5,
    cy: 800.9,
    r: 8.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_43",
    x: 1517.9,
    y: 833.5,
    transform: "matrix(-0.6373 -0.7706 0.7706 -0.6373 1911.3223 2572.8049)",
    className: "st19",
    width: 86.4,
    height: 6.3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_44",
    x: 1507.2,
    y: 765,
    transform: "matrix(-0.1093 -0.994 0.994 -0.1093 944.7617 2378.6101)",
    className: "st19",
    width: 61.7,
    height: 2.1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_45",
    x: 1525,
    y: 832.1,
    transform: "matrix(-0.5765 -0.8171 0.8171 -0.5765 1788.1624 2593.1047)",
    className: "st19",
    width: 82.2,
    height: 2.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_154",
    className: "st26",
    d: "M1439.8,791.1l63.3-8c5.5-0.7,9.9-4,10.9-8l5.7-23.7l-104.7,13.2l12.2,21.6 C1429.4,789.8,1434.4,791.8,1439.8,791.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_155",
    className: "st26",
    d: "M1374.5,752.6l181.8-22.9c-6.3-50.2-52.2-85.7-102.4-79.4c-48.7,6.2-83.9,49.6-79.8,98.5 C1374.2,750,1374.3,751.3,1374.5,752.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_156",
    className: "st27",
    d: "M1408.7,739.4c-10.2-70.6,34-87,34-87c-43.3,11.1-72.2,51.8-68.5,96.3L1408.7,739.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_157",
    className: "st6",
    d: "M1369.4,750.7l2.7,21.5c0.4,3.4,3.6,5.9,7,5.4c0,0,0,0,0,0l76.7-9.7l102-12.9 c3.4-0.4,5.9-3.6,5.4-7c0,0,0,0,0,0l-2.7-21.5c-0.4-3.4-3.6-5.9-7-5.4c0,0,0,0,0,0l-110.3,13.9l-68.4,8.6 C1371.4,744.2,1368.9,747.3,1369.4,750.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_158",
    className: "st28",
    d: "M1369.4,750.7l2.7,21.5c0.4,3.4,3.6,5.9,7,5.4c0,0,0,0,0,0l76.7-9.7 c-13.5-10.2-12.6-32.3-12.6-32.9l-68.4,8.6C1371.4,744.2,1369,747.3,1369.4,750.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_50",
    className: "st19",
    d: "M1478.6,683L1478.6,683c-19.1,2.4-32.6,19.8-30.2,38.9l1.6,12.3l0,0l69.1-8.7l0,0 l-1.6-12.3C1515.1,694.1,1497.7,680.6,1478.6,683z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_159",
    className: "st29",
    d: "M1487.6,715.3c0.5,0,0.9-0.4,1-1c0-0.4,1-10.2,8.8-11.2c7.9-1,11.3,8.5,11.3,8.6 c0.2,0.6,0.8,0.8,1.3,0.6c0.6-0.2,0.8-0.8,0.6-1.3c-0.7-1.9-1.8-3.8-3.1-5.4c-3.5-5-10.5-6.2-15.5-2.7c-1.8,1.3-3.2,3.1-4,5.1 c-0.9,1.9-1.4,3.9-1.7,6c-0.1,0.6,0.4,1.1,1,1.1c0,0,0,0,0,0C1487.5,715.3,1487.6,715.3,1487.6,715.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_160",
    className: "st29",
    d: "M1455.2,719.4c0.5,0,0.9-0.4,1-1c0-0.4,1-10.2,8.8-11.2c7.8-1,11.2,8.2,11.3,8.6 c0.2,0.5,0.8,0.8,1.4,0.6c0.5-0.2,0.8-0.8,0.6-1.3c-0.7-1.9-1.8-3.8-3.1-5.4c-3.5-5-10.5-6.2-15.5-2.7c-1.8,1.3-3.2,3.1-4,5.1 c-0.9,1.9-1.4,3.9-1.7,6c-0.1,0.6,0.4,1.1,1,1.1c0,0,0,0,0,0C1455.1,719.4,1455.1,719.4,1455.2,719.4z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5",
    transform: "translate(1194.629 638.906)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_51",
    x: 308.8,
    y: 122.8,
    transform: "matrix(-0.997 -7.723141e-002 7.723141e-002 -0.997 607.4739 290.5262)",
    className: "st27",
    width: 1.1,
    height: 21.4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_52",
    x: 297.3,
    y: 124.4,
    transform: "matrix(-0.9996 -2.989244e-002 2.989244e-002 -0.9996 591.4473 278.7904)",
    className: "st27",
    width: 1.1,
    height: 21.2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_53",
    x: 285.7,
    y: 125.9,
    transform: "matrix(-0.9983 5.896921e-002 -5.896921e-002 -0.9983 580.0674 255.7508)",
    className: "st27",
    width: 1.1,
    height: 21
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_54",
    x: 229.4,
    y: 141.7,
    transform: "matrix(-0.3226 -0.9465 0.9465 -0.3226 182.8734 415.4042)",
    className: "st27",
    width: 21.4,
    height: 1.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161",
    className: "st27",
    d: "M255.1,150.9l-1,0.3l-5.9-20.4l1-0.3L255.1,150.9z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_55",
    x: 264.2,
    y: 137.4,
    transform: "matrix(-0.1258 -0.9921 0.9921 -0.1258 172.4888 427.7748)",
    className: "st27",
    width: 21,
    height: 1.1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_56",
    x: 251.6,
    y: 139,
    transform: "matrix(-0.2109 -0.9775 0.9775 -0.2109 181.0075 425.098)",
    className: "st27",
    width: 21.1,
    height: 1.1
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_57",
    x: 1381.4,
    y: 659.2,
    transform: "matrix(-0.1249 -0.9922 0.9922 -0.1249 933.0102 2143.4521)",
    className: "st19",
    width: 60.8,
    height: 2.1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_27",
    className: "st19",
    cx: 1407.8,
    cy: 628.6,
    r: 3.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_58",
    className: "st6",
    d: "M1415.1,687L1415.1,687c-3,0.4-5.2,3.1-4.8,6.1l0.5,3.8l0,0l10.9-1.4l0,0l-0.5-3.8 C1420.9,688.7,1418.1,686.6,1415.1,687z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_28",
    className: "st19",
    cx: 1391.5,
    cy: 760.1,
    r: 13.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_59",
    x: 1369.9,
    y: 766.7,
    transform: "matrix(-0.8993 -0.4374 0.4374 -0.8993 2257.4888 2112.8452)",
    className: "st19",
    width: 4.2,
    height: 59.4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_29",
    className: "st19",
    cx: 1360.3,
    cy: 829.7,
    r: 8.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_60",
    x: 1340.1,
    y: 862.4,
    transform: "matrix(-0.6378 -0.7702 0.7702 -0.6378 1599.5685 2481.2783)",
    className: "st19",
    width: 86.3,
    height: 4.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_162",
    className: "st19",
    d: "M1407.8,895.1l-1,0.7c-4.1,2.9-5.5,8.3-3.3,12.8l6.8,13.6l19.1-16.2l-8.1-9.3 C1417.9,892.9,1412.1,892.2,1407.8,895.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_163",
    className: "st19",
    d: "M1413.7,901.3c0.1,0,0.1,0,0.2,0l21-2.5c1.7-0.2,3-1.7,2.9-3.4c-0.2-1.7-1.7-3-3.4-2.9 c-0.1,0-0.1,0-0.2,0l-21,2.5c-1.7,0.2-3,1.8-2.7,3.5C1410.6,900.2,1412,901.4,1413.7,901.3L1413.7,901.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_164",
    className: "st19",
    d: "M1434.8,923.3c1.7-0.1,3.1-1.6,2.9-3.4c0-0.5-0.2-1-0.5-1.5l-8.2-13c-0.9-1.5-2.9-1.9-4.4-1 c-1.5,0.9-1.9,2.9-1,4.4l8.2,13C1432.5,922.9,1433.7,923.4,1434.8,923.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_165",
    className: "st19",
    d: "M1427.5,928.7c1.7-0.1,3.1-1.6,2.9-3.4c0-0.5-0.2-0.9-0.4-1.3l-7.7-13.8 c-0.8-1.5-2.7-2.1-4.3-1.3c-1.5,0.8-2.1,2.7-1.3,4.3c0,0,0,0.1,0.1,0.1l7.7,13.8C1425.1,928.1,1426.2,928.8,1427.5,928.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_166",
    className: "st19",
    d: "M1417.3,929.9c1.7-0.1,3.1-1.6,2.9-3.4c0-0.5-0.2-0.9-0.4-1.4l-4.8-8.2 c-0.9-1.5-2.8-2-4.3-1.2c-1.5,0.9-2,2.8-1.2,4.3c0,0,0,0,0,0l4.7,8.2C1415,929.4,1416.1,930,1417.3,929.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_167",
    className: "st19",
    d: "M1586.4,865.8l-1,0.7c-4.1,2.9-5.5,8.3-3.3,12.8l6.8,13.6l19.1-16.2l-8.1-9.3 C1596.4,863.5,1590.6,862.8,1586.4,865.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_168",
    className: "st19",
    d: "M1592.2,872l0.2,0l21-2.5c1.7-0.3,2.9-1.9,2.7-3.6c-0.2-1.7-1.7-2.8-3.4-2.7l-21,2.5 c-1.7,0.2-3,1.8-2.7,3.5C1589.1,870.9,1590.6,872.1,1592.2,872L1592.2,872z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_169",
    className: "st19",
    d: "M1613.3,894c1.7-0.1,3.1-1.6,2.9-3.4c0-0.5-0.2-1-0.5-1.5l-8.2-13c-0.9-1.5-2.9-1.9-4.4-1 c-1.5,0.9-1.9,2.9-1,4.4l0,0l8.2,13C1611.1,893.5,1612.2,894,1613.3,894z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_170",
    className: "st19",
    d: "M1606,899.3c1.7-0.1,3.1-1.6,2.9-3.4c0-0.5-0.2-0.9-0.4-1.3l-7.7-13.8 c-0.9-1.5-2.8-2-4.3-1.1c-1.5,0.9-2,2.7-1.2,4.2l7.7,13.8C1603.6,898.8,1604.8,899.4,1606,899.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_171",
    className: "st19",
    d: "M1595.8,900.6c1.7-0.1,3.1-1.6,2.9-3.4c0-0.5-0.2-0.9-0.4-1.4l-4.8-8.2 c-0.9-1.5-2.8-2-4.3-1.1c-1.5,0.9-2,2.8-1.1,4.3l4.8,8.2C1593.5,900,1594.6,900.6,1595.8,900.6z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_61",
    x: 1377.7,
    y: 768.6,
    transform: "matrix(-0.8991 -0.4378 0.4378 -0.8991 2268.2034 2121.9502)",
    className: "st19",
    width: 2.1,
    height: 61.9
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_62",
    x: 1347.1,
    y: 860,
    transform: "matrix(-0.5765 -0.8171 0.8171 -0.5765 1485.001 2491.6702)",
    className: "st19",
    width: 82.2,
    height: 2.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_182",
    className: "st19",
    d: "M1613.3,894c1.7-0.1,3.1-1.6,2.9-3.4c-0.1-0.9-0.5-1.8-1.3-2.3l-6.2-4.6 c-1.4-1-3.4-0.7-4.4,0.7c-1,1.4-0.7,3.3,0.6,4.4l6.2,4.6C1611.8,893.8,1612.6,894,1613.3,894z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_183",
    className: "st19",
    d: "M1595.8,900.6c1.7-0.1,3.1-1.6,2.9-3.4c-0.1-1.1-0.7-2-1.6-2.5l-4.8-2.7 c-1.5-0.9-3.4-0.4-4.3,1.1c-0.9,1.5-0.4,3.4,1.1,4.3c0,0,0.1,0,0.1,0.1l4.8,2.7C1594.6,900.5,1595.2,900.6,1595.8,900.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_184",
    className: "st19",
    d: "M1606,899.3c1.7-0.1,3.1-1.6,2.9-3.4c-0.1-0.8-0.4-1.5-0.9-2l-6.8-6.7 c-1.2-1.2-3.3-1.2-4.5,0c-1.2,1.2-1.2,3.3,0,4.5l0,0l6.8,6.7C1604.2,899.1,1605.1,899.4,1606,899.3z"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M555.3,173.8c0,0,0.9-47,39.6-55.2c47.8-10.1,66.2,23.1,66.2,56.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st30",
    d: "M585.3,121.7c-6.8,3.1-11.9,7.6-15.9,12.8c-3.3,8.9-3.5,14.4-3.5,14.4l8.4-1.4 C574.5,138.5,583.1,125.1,585.3,121.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M609.1,114.8c0,0-32.6,1.8-35,54.1h31.9c0,0-4.2-43.2,21-49.9l0,0c0-1.9-1.6-3.5-3.6-3.6L609.1,114.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M607,171.6h-30.9c-1.9,0-3.5-1.6-3.5-3.5v-23.4c0-1.9,1.6-3.5,3.5-3.5H607c1.9,0,3.5,1.6,3.5,3.5v23.4 C610.5,170,609,171.6,607,171.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M536.4,175.5l113.5-0.3c0,0-23.5-13.6-63.9-13.6S536.4,175.5,536.4,175.5z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st30",
    d: "M646.5,131.2c-3.6-3.9-7.8-7.2-12.9-9.7c-5.3,2.4-13.1,9.4-14.7,30.1c10.9,1.1,18.5,1.8,18.5,1.8 S638.7,140.8,646.5,131.2z"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M355.8,70.8c0,0-6.4-38.1-38.8-40.1c-40.1-2.4-51,26.7-47,54"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st30",
    d: "M325.2,32.1c5.9,1.7,10.6,4.8,14.4,8.5c3.8,6.8,4.6,11.3,4.6,11.3l-7-0.1C336,44.4,327.5,34.5,325.2,32.1z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M305.1,29.4c0,0,26.7-2.5,34.9,39.7L314,72.9c0,0-1.8-35.6-23-38l0,0c-0.2-1.6,0.9-3.1,2.5-3.4L305.1,29.4 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M313.6,75.2l25.1-3.7c1.6-0.2,2.7-1.7,2.4-3.3l-2.8-19c-0.2-1.6-1.7-2.7-3.3-2.4l-25.1,3.7 c-1.6,0.2-2.7,1.7-2.4,3.3l2.8,19C310.5,74.4,312,75.4,313.6,75.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M371.4,69.9l-92.3,13.4c0,0,17.5-13.9,50.3-18.8C362.2,59.8,371.4,69.9,371.4,69.9z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st30",
    d: "M276.6,47.1c2.4-3.6,5.5-6.8,9.3-9.4c4.6,1.3,11.8,6.1,15.5,22.7c-8.7,2.2-14.8,3.7-14.8,3.7 S284.1,54,276.6,47.1z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkInProgress);
export default __webpack_public_path__ + "static/media/work-in-progress.b9b210c24b247a26b0be5506ccb8a8a4.svg";
export { ForwardRef as ReactComponent };